// IXICO 2026 "glass purple-blue" tokens for system/utility screens (404, error,
// access denied, session expired, service unavailable) and the sign-in preloader.
// Mirrors the approved Azure AD B2C theme (glass-purple-blue-b2c.css): a deep
// blue -> purple gradient, floating blurred orbs, translucent glass surfaces,
// and a blue -> purple primary action. Hard-coded (not theme colour tokens)
// because these screens must hold the exact brand colours regardless of theme.

// Page background - deep navy -> indigo -> purple, 135°.
export const BG_GRADIENT =
  "linear-gradient(135deg, #020817 0%, #0a1a3e 30%, #1e2a5f 60%, #2d1b4e 100%)";

// Primary action gradient (blue -> purple) + hover.
export const BUTTON_GRADIENT = "linear-gradient(to right, #2563eb, #7c3aed)";
export const BUTTON_GRADIENT_HOVER = "linear-gradient(to right, #3b82f6, #8b5cf6)";

export const BLUE_300 = "#93c5fd"; // input icons, links
export const GLOW_BLUE = "0 0 40px rgba(56, 100, 255, 0.3)";
export const LOGO_GLOW = "drop-shadow(0 4px 20px rgba(56, 100, 255, 0.4))";

// Glass surfaces.
export const GLASS_BG = "rgba(255, 255, 255, 0.05)";
export const GLASS_BORDER = "rgba(255, 255, 255, 0.1)";

// Floating background orbs.
export const ORB_BLUE = "rgba(37, 99, 235, 0.2)";
export const ORB_PURPLE = "rgba(147, 51, 234, 0.15)";
